<div class="modal fade show lrtdrtavailablity-modal" tabindex="-1" role="dialog"
    [ngStyle]="{display: visible ? 'block' : 'none'}" aria-modal="true" *ngIf="visible">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div>
                    <h5 class="modal-title">{{teacherData?.teacher?.user?.full_name}}</h5>
                    <span class="user-sub-title mt-2">{{teacherData?.teacher?.meta?.you_are_a}}</span>
                    <span class="{{teacherData?.teacher?.qld_data?.role_type}} ms-2 role_tag_qld user-title-m"> {{teacherData?.teacher?.qld_data?.role_type}}</span>
                </div>
                <button type="button" class="close" aria-label="Close" (click)="close()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="availability-summary-card">
                    <div class="summary-item">
                        <h4>{{contractAvailability?.actual_roster_days}}/{{contractAvailability?.total_days}}</h4>
                        <p>Available Contract Days</p>
                        <span class="highlight">{{contractAvailability?.roster_percentage}}% coverage</span>
                    </div>

                    <div class="summary-item">
                        <h4>{{contractAvailability?.total_days}} days</h4>
                        <p>Booking period</p>
                        <!-- <span>{{bookingPeriod}}</span> -->
                    </div>

                    <div class="summary-item">
                        <h4>{{bookingDetails?.start_time}} - {{bookingDetails?.end_time}}</h4>
                        <p>Daily hours</p>
                        <span>{{totalBookingHours}} per day</span>
                    </div>
                </div>
                <div class="availability-legend d-flex justify-content-between mt-4 align-items-center">
                    <div class="legend-item">
                        <span class="dot available"></span>
                        <span>Available</span>
                    </div>
                    @if(teacherData?.teacher?.qld_data?.role_type == 'LRT'){
                    <div class="legend-item">
                        <span class="dot lrt"></span>
                        <span>LRT</span>
                    </div>
                    }@else{
                    <div class="legend-item">
                        <span class="dot drt"></span>
                        <span>DRT</span>
                    </div>
                    }

                    <div class="legend-item">
                        <span class="dot casual"></span>
                        <span>Booked</span>
                    </div>

                    <div class="legend-item">
                        <span class="dot unavailable"></span>
                        <span>Unavailable</span>
                    </div>
                    <div class="legend-item">
                        <span class="dot haventindicated"></span>
                        <span>Haven't Indicated</span>
                    </div>
                    <div class="legend-item">
                        <span class="dot booked_externally"></span>
                        <span>Booked Externally</span>
                    </div>
                </div>

                <div class="calendar-grid">
                    <div class="calendar-day" *ngFor="let day of availabilityLrtDrt">

                        <!-- DATE HEADER -->
                        <div class="date-header">
                            <div class="day-name">{{ day.day }}</div>
                            <div class="day-date">{{ day.month }}</div>
                        </div>
                        <!-- <div class="top-icon">
                        <i class="bi bi-building"></i>
                        </div> -->

                        <!-- EXISTING CIRCLE -->
                        <div class="day-circle" [ngClass]="{
                            split: day.intervals.length === 2,
                            available: day.intervals[0].status === 'available',
                            lrt: day.intervals[0].status === 'lrt_contract',
                            drt: day.intervals[0].status === 'drt_contract',
                            haventindicated: day.intervals[0].status === 'haventindicated',
                            booked_externally: day.intervals[0].status === 'booked_externally',
                            casual: day.intervals[0].status === 'casual',
                            unavailable: day.intervals[0].status === 'unavailable',
                            booked: day.intervals[0].status === 'booked'
                        }">

                            <ng-container *ngIf="day.intervals.length === 2">
                                <span class="half left" [ngClass]="day.intervals[0].status"></span>
                                <span class="half right" [ngClass]="day.intervals[1].status"></span>
                            </ng-container>

                            <span class="day-number">{{ day.date }}</span>
                        </div>

                    </div>
                </div>


            </div>
        </div>
    </div>
</div>